<template>
  <div id="campaign_recall_vin_list">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="canAccessPage === true">
        <div class="page-name">
          <div class="page-title">Campaign & Recall Status Tracker</div>

          <div class="web-action-btn btn-groups text-right">
            <!-- Button for Clear Cache -->
              <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="from-group">
            <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong id="errorMsg" class="field-error"></strong>
            </div>
          </div>
          <div class="admin-page-content campaign-recall-status-list">
            <data-table-filter-config :moduleName="'campaignRecallVinList'" :allowSameFilter="'allow'"></data-table-filter-config>
            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
            <section class="data-table bg-white">
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange" :moduleName="'campaignRecallVinList'" :position="'top'">
              </custom-pagination>
              <vue-good-table
                ref="campaignRecallVinList"
                mode="remote"
                title="Campaign/Recall Vin Numbers"
                @on-page-change="onPageChange"
                @on-selected-rows-change="selectionChanged"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                :totalRows="totalRecords"
                :columns="userColumns"
                :rows="rows"
                :pagination-options="{
                    enabled: false,
                    position: 'both',
                    perPage: perPage,
                    perPageDropdown:dropDownPerPage,
                    dropdownAllowAll: false,
                }"
                :select-options="{
                    enabled: true,
                    selectOnCheckboxOnly: true,
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                }"
                :search-options="{
                    enabled: false,
                }">

                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                  <div :key="key">
                    <div v-if="props.column.field == 'action'">
                      <a v-if="canViewLog" title="View Log" v-on:click.prevent="goToGetLogInfo(props.row.id)" class="fp-log-file-format" href="javascript:void(0)"></a>
                      <router-link title="Edit Campaign/Recall Vin" v-if="canUpdateVin" class="fp-edit" v-bind:to="{name: 'CampaignRecallVinCreate',params:{id:props.row.id}}"></router-link>
                    </div>
                    <div>
                      {{props.formattedRow[props.column.field]}}
                    </div>
                  </div>
                </template>
              </vue-good-table>
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
        <audit-log-popup :logs="logs" :popUpTitle="popUpTitle"></audit-log-popup>
      </template>
      <template v-else-if="canAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>

  </div>
</template>
<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import EventBus from "../event-bus";

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import AuditLogPopUp from "../AuditLogPopUp.vue";
Vue.component("audit-log-popup",AuditLogPopUp);

export default {
  name: "CampaignRecallVinList",
  components: {
    customPagination: () => import('@/components/layout/CustomPagination'),
    dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
    clearCacheData: () => import('@/components/ClearCacheData'),
    appFooter: () => import('@/components/Footer'),
  },
  mixins:[commonMixins,dataTableMixins],
  metaInfo() {
    return {title: "Status Tracking | " + process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    canAccessPage: "",
    userColumns:[],
    columns: [
      {
        label: 'Actions',
        field: 'action',
        sortable: false,
      },
      {
        label: 'Vin',
        field: 'vin',
        fpFieldType:"text",
        hidden:false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Vin", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Campaign / FFP code',
        field: 'ffp_code',
        fpFieldType:"text",
        hidden:false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "FFP Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'FFP Description',
        field: 'ffp_description',
        fpFieldType:"text",
        hidden:false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "FFP Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Campaign Start Date',
        field: 'campaign_start_date',
        fpFieldType:"date",
        hidden:false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
        // sortable:false
      },
      {
        label: 'Campaign End Date',
        field: 'campaign_end_date',
        fpFieldType:"date",
        hidden:false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
        // sortable:false
      },
      {
        label: 'Claim Status',
        field: 'status',
        fpFieldType:"option",
        hidden:false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Claim Status", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          filterDropdownItems: [],
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Claim Date',
        field: 'claim_date',
        fpFieldType:"date",
        hidden:false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Claim Date", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Claim Number',
        field: 'claim_number',
        fpFieldType:"text",
        hidden:false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Claim Number", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ],
    rows: [],
    totalRecords: 0,
    loading:false,
    canUpdateVin:false,
    pageKey:"_campaign_recall_vin_list_",
    errorMsg: "",
    action: "list",
    firstLoad: 0,
    batchProcess:0,
    canViewLog: false,
    logs: [],
    popUpTitle: "Campaign & Recall Status Activity Log Details",

  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name === 'ev_list_campaign_recall_vin') {
            self.canAccessPage = true;
          }
          if (permissions[i].name === 'ev_edit_campaign_recall_vin') {
            self.canUpdateVin = true;
          }
          if (permissions[i].name === 'ev_view_log_campaign_recall_vin') {
            self.canViewLog = true;
          }
        }
      }

    }
  },
  mounted: function() {
    var self = this;
    self.getPermissions();
  },
  methods: {
    cancelAll: function () {
      this.$refs.campaignRecallVinList.unselectAllInternal();
    },
    selectionChanged(param) {
      if(param.selectedRows.length === 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
    },
    loadList() {
      var self = this;
      self.loading = true;
      var selectedRows = [];
      if ( self.firstLoad == 1 ) {
          //because on first load list not initialize
          var data = this.$refs['campaignRecallVinList'].selectedRows;
          for ( var i = 0; i < data.length; i++ ) {
              selectedRows.push(this.$refs['campaignRecallVinList'].selectedRows[i].id)
          }
      }
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        sort: self.serverParams.sort,
        selectedRows:selectedRows,
        action:self.action,
        selectedAll:self.serverParams.selectedAll
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/campaign-recall-vin/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            if ( self.action == "export" ||  self.action == "export_queue") {
              if ( data.code == "201" ) {
                  alert(data.message);
              } else {
                  if ( self.action == "export" ) {
                      var save = document.createElement("a");
                      save.href = data.content;
                      save.download = data.content;
                      save.target = "_blank";
                      document.body.appendChild(save);
                      save.click();
                      document.body.removeChild(save);
                  } else {
                      self.batchProcess = 1;
                      self.batchNum = data.content;
                  }
              }
              self.action = "list";
            }else{
              self.rows = data.content.row;
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          if (self.action =='export' || self.action == "export_queue")
          {
              self.generateStatusCodeMessage(jqXHR,true,'campaign-recall-status-export-error')
          }else{
              self.generateStatusCodeMessage(jqXHR,false,'campaign-recall-status-error')
          }
        }
      });
    },
    exportCheck: function() {
        var count = 0;
        var actionFlag = "";
        var data = this.$refs['campaignRecallVinList'].selectedRows;
        count = data.length;

        if(this.serverParams.selectedAll == true){
            actionFlag = "";
        }else if(count != 0 && count <= 100){
            actionFlag = "export";
        }

        this.exportReports(actionFlag);
    },

    goToGetLogInfo(logId){
        var self = this;
        var logFlag = 'CAMPAIGN_VIN_AUDIT';

        self.getLogInfo(logId, logFlag);
    },
  }
};
</script>

<style scoped>
.data-table table.vgt-table .fp-log-file-format {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignRecallVinList.vue